import { useSelector } from 'react-redux';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getCurrentInboxAccessUrl } from 'conversations-external-deep-links/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdminNonMemberWarning = ({
  closeWarning
}) => {
  const currentInboxId = useSelector(getCurrentInboxId);
  const currentInboxAccessUrl = currentInboxId ? getCurrentInboxAccessUrl({
    inboxId: currentInboxId
  }) : '/';
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.unified-inbox.warning.title"
    }),
    closeable: true,
    onClose: closeWarning,
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.unified-inbox.warning.info"
        })
      }), /*#__PURE__*/_jsx(UILink, {
        href: currentInboxAccessUrl,
        children: /*#__PURE__*/_jsx(UIButton, {
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.unified-inbox.warning.button"
          })
        })
      })]
    })
  });
};
AdminNonMemberWarning.displayName = 'AdminNonMemberWarning';
export default AdminNonMemberWarning;